/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';
import { render } from 'react-dom';
import 'react-leaflet-fullscreen-control';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-geosearch/assets/css/leaflet.css';
import './styles/mediaPrintOnly.css';

// Helpers
import { setMessagingToken } from 'helpers/auth';

// Services
import { myFirebase } from 'services/firebase';
import { getMessaging, getToken } from 'firebase/messaging';

// Bugsnag
// @ts-ignore
import BugsnagPluginReact from '@bugsnag/plugin-react';
import Bugsnag from '@bugsnag/js';

import App from './App';

Bugsnag.start({
  apiKey: '5b578f34138aceef71ced57d6ecb9f53',
  plugins: [new BugsnagPluginReact()],
});

const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React);

render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,

  document.getElementById('root'),
);

/*
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 * serviceWorker.unregister();
 */

// Initialize messaging
const messaging = getMessaging(myFirebase);

// Register Service Worker and Get Token
navigator.serviceWorker
  .register('./firebase-messaging-sw.js')
  .then(async (registration) => {
    // Firebase automatically uses the registered service worker
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, {});
      setMessagingToken(token);
    } else {
      console.error('Permission for notifications was denied.');
    }
  })
  .catch((error) => {
    console.error('Service Worker registration or token retrieval failed:', error);
  });
